// React
import React, {Component}  from 'react';

// Interface del usuario (GUI)
import {CardImage, CardBody, CardTitle, CardText, Card, Button, Row } from 'mdbreact' 
import './ServicioItem.css'

// Routing
import { withRouter } from 'react-router-dom'


class ServicioItem extends Component  {
  
  onClickInfo = (event, rutaInfo) => {
    console.log (rutaInfo)
    this.props.history.push(rutaInfo)
    event.preventDefault()
  }
  
  onClickCotizacion = (event, rutaCotizacion) => {
    this.props.history.push(rutaCotizacion)
    event.preventDefault()
  }

  render () {
    const {id, titulo, foto, texto, subservicios} = this.props 
    return (
      // <Card key = {id} className='d-flex align-items-stretch' >
      // <Card key = {id} className='row h-25 w-25 d-inline-block ml-4 mt-4 mb-4' >
      // <Card key = {id} className= 'row servicio-item-sz d-inline-block ml-4 mt-4 mb-4' >
      <Card key = {id} className='row d-inline-block ml-4 mt-4 mb-4 servicio-item-card-sz' >
        <CardImage  className="img-fluid servicio-item-card-image-sz " src={require('../imagenes/' + foto) }/>
        <CardBody>
          <CardTitle className= 'servicio-item-card-title-sz'>{titulo}</CardTitle>
          <CardText className= 'servicio-item-card-text-sz'>{texto}</CardText>
          <Row>
            <div className="col-6">
              <Button size='sm' onClick={ event  => this.onClickInfo(event, this.props.rutaInfo) } href="#">Información</Button>
            </div>
            <div className="col-6">
              <Button size='sm'  onClick={ event  => this.onClickCotizacion(event, this.props.rutaCotizacion) } >Cotización</Button>
            </div>
          </Row>
        </CardBody>
      </Card>
    ) //fin return
  }
} //fin class

// export default ServicioItem
export default withRouter(ServicioItem)


// WEBPACK FOOTER //
// ./src/componentes/ServicioItem.js